import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { SocialService } from 'src/app/shared/services/angular-service/social.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';

interface Tag {
  _id: string;
  userId: string;
  name: string;
  type: string;
  value: string;
  title: string;
  settingType: string;
  createdAt: string;
  updatedAt: string;
}

@Component({
  selector: 'app-feed-create-post-popup',
  templateUrl: './feed-create-post-popup.component.html',
  styleUrls: ['./feed-create-post-popup.component.scss'],
})
export class FeedCreatePostPopupComponent implements OnInit, OnDestroy {
  @Output() postCreated: EventEmitter<any> = new EventEmitter();

  paginationRequest = {
    field: 'name',
    order: 1,
    rows: 10,
    page: 0,
    filter: {},
    totalRecords: 0,
  };

  paginationRequestTags = {
    field: 'name',
    order: 1,
    rows: 10,
    page: 0,
    filter: {},
    totalRecords: 0,
  };

  public isSearching = true;
  public selectedSearch: string = '';

  public isSearchingTags = true;
  public selectedSearchTags: string = '';
  noMore: boolean;

  autofocus = true;
  companyList: any = [];
  postForm!: UntypedFormGroup;
  private subscription = new Subscription();
  showDropdown: boolean = false;
  showTagDropdown: boolean = false;
  selectedCompany: any;
  tagList: any = [];

  constructor(
    private companyService: CompanyService,
    private fb: UntypedFormBuilder,
    protected socialService: SocialService,
    private toastService: ToastService,
    private router: Router
  ) {
    this.postForm = this.fb.group({
      searchInput: ['', Validators.required],
      searchTag: [''],
      content: [
        '',
        [
          Validators.required,
          Validators.minLength(20),
          ,
          Validators.maxLength(240),
        ],
      ],
      hashTag: [],
      anonymous: [false, Validators.required],
    });
  }

  ngOnInit(): void {
    this.activeSubscription();
    this.getCompanies();
    this.getHashTags();
  }

  onCompanyScroll(event) {
    this.paginationRequest.page++;
    if (
      this.paginationRequest.page >=
      this.paginationRequest.totalRecords / this.paginationRequest.rows
    ) {
      this.noMore = true;
    } else {
      this.getCompanies();
    }
  }

  onTagScroll(event) {
    // console.log(this.paginationRequestTags);
    this.paginationRequestTags.page++;
    if (
      this.paginationRequestTags.page >=
      this.paginationRequestTags.totalRecords / this.paginationRequestTags.rows
    ) {
      // this.noMore = true;
    } else {
      this.getHashTags();
    }
  }

  get content() {
    return this.postForm.get('content');
  }

  get hashTag() {
    return this.postForm.get('hashTag');
  }

  get anonymous() {
    return this.postForm.get('anonymous');
  }

  get searchInput() {
    return this.postForm.get('searchInput');
  }

  get searchTag() {
    return this.postForm.get('searchTag');
  }

  getCompanies() {
    this.isSearching = true;
    let query = {
      field: this.paginationRequest.field,
      order: this.paginationRequest.order,
      rows: this.paginationRequest.rows,
      page: this.paginationRequest.page,
      filter: this.paginationRequest.filter,
      textSearch: this.selectedSearch,
    };
    this.companyService
      .getCompanies(query)
      .then((data) => {
        this.companyList =
          this.paginationRequest.page === 0
            ? data['data']
            : [...this.companyList, ...data['data']];
        this.paginationRequest.totalRecords = data['totalRecords']
          ? data['totalRecords']
          : 0;
        this.isSearching = false;
      })
      .catch((err: any) => {
        this.isSearching = false;
      });
  }

  getHashTags() {
    this.isSearching = true;
    let query = {
      // field: this.paginationRequestTags.field,
      // order: this.paginationRequestTags.order,
      rows: this.paginationRequestTags.rows,
      page: this.paginationRequestTags.page,
      filter: this.paginationRequestTags.filter,
      search: this.selectedSearchTags,
    };
    this.socialService
      .getTagList(query)
      .then((data: any) => {
        this.tagList =
          this.paginationRequestTags.page == 0
            ? data['result'].result
            : [...this.tagList, ...data['result'].result];

        this.paginationRequestTags.totalRecords = data['result']['totalRecords']
          ? data['result']['totalRecords']
          : 0;
        this.isSearching = false;
      })
      .catch((err: any) => {
        console.log(err);
        this.isSearching = false;
      });
  }

  activeSubscription() {
    this.subscription.add(
      this.postForm
        .get('searchInput')
        .valueChanges.pipe(
          debounceTime(300),
          distinctUntilChanged(),
          switchMap((value: any) => {
            this.selectedSearch = value;
            this.getCompanies();
            return value;
          }),
        )
        .subscribe(() => {
          // console.log('sub');
        }),
    );

    this.subscription.add(
      this.postForm
        .get('searchTag')
        .valueChanges.pipe(
          debounceTime(300),
          distinctUntilChanged(),
          switchMap((value: any) => {
            // console.log('value ', value);
            this.selectedSearchTags = value;
            this.getHashTags();
            return value;
          }),
        )
        .subscribe(() => {
          // console.log('sub');
        }),
    );
  }

  onSearchChange(): void {
    this.paginationRequest.page = 0;
    this.showDropdown = true;
  }

  selectDataValue(item) {
    this.showDropdown = false;
    this.selectedCompany = item;
    this.postForm.get('searchInput')!.setValue(item.name);
  }

  onSearchChangeTag(): void {
    this.paginationRequestTags.page = 0;
    this.showTagDropdown = true;
  }

  selectDataValueTag(tag: Tag) {
    this.showTagDropdown = false;
    const hashTags = this.postForm.get('hashTag').value;
    this.postForm.get('searchTag')!.setValue(tag.title);
    // TODO : This code to be used when we have multiple tags and we need to show them is certain way
    // if (hashTags && !hashTags.some((t) => t.name === tag.name)) {
    //   hashTags.push(tag.name);
    //   this.postForm.get('hashTag').setValue(hashTags);

    //   this.tagList = this.tagList.filter((t) => t.name !== tag.name);
    // }else{
    //   this.postForm.get('hashTag').setValue([tag.name]);
    // }
  }

  // TODO : This code to be used when we have multiple tags and we need to remove them is certain way
  // removeDataValueTag(tag: Tag): void {
  //   const hashTags = this.postForm.get('hashTag').value;
  //   let val = hashTags.filter((t) => t.name !== tag);
  //   this.postForm.get('hashTag').setValue(hashTags.filter((t) => t !== tag));
  //   this.tagList.push(tag);
  // }

  hideDropdown(): void {
    setTimeout(() => {
      this.showDropdown = false;
      this.showTagDropdown = false;
    }, 200);
  }

  submit() {
    let requestData = {
      type: this.anonymous.value ? 'ANONYMOUS' : 'PSEUDONYMOUS',
      cin: this.selectedCompany.cin,
      tags: this.searchTag.value ? [this.searchTag.value] : null,
      content: this.content.value,
      industry: this.selectedCompany.industry,
      layout: 'USER_POST',
    };
    this.socialService
      .createPost(requestData)
      .then((data: any) => {
        this.postCreated.emit();
        this.toastService.addSingle('success', 'Post Created Success', '');
        this.postForm.reset();
        this.router.navigate(['/account/posts']);
      })
      .catch((err: any) => {
        console.log(err);
        this.toastService.addSingle(
          'error',
          'Error',
          err.message || 'Something Went wrong',
        );
      });
  }

  ngOnDestroy(): void {
    this.postForm.reset();
    this.subscription.unsubscribe();
  }
}
